module.exports = __webpack_public_path__ + "media/images/plant_agric-600d52f9f6d0d053b4b91de851cb49cf.svg";